import { AdminUsagePage } from '@features/admin/components/AdminUsagePage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/admin/usage')({ component: AdminUsagePage });
